import { render, staticRenderFns } from "./AutocompletePopup.vue?vue&type=template&id=3ace5f3f&scoped=true&"
import script from "./AutocompletePopup.vue?vue&type=script&lang=js&"
export * from "./AutocompletePopup.vue?vue&type=script&lang=js&"
import style0 from "./AutocompletePopup.vue?vue&type=style&index=0&id=3ace5f3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace5f3f",
  null
  
)

export default component.exports